import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom"
import { ToastContent, toast } from "react-toastify";
import { handleLoader } from "redux/counterSlice";
import { black_listed_word, get_black_listed_word_by_id, update_black_listed_word } from "services/voiceInteractionService";

const AddBlackListWord = ({ permissions }: any) => {

    const params = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm()
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fetchBlackListWordData = async (id: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await get_black_listed_word_by_id(id)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setValue("black_listed_word", result.word)
            // setValue("description", result.description)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const onSubmit = async (data: any) => {
        const createBy = localStorage.getItem("username")
        dispatch(handleLoader(true));
        // data.user_name = sessionStorage.getItem("username");
        // try {
        //     const { result, error } = await black_listed_word(data);
        //     if (error) {
        //         throw error
        //     }
        //     if (result?.error) {
        //         throw result.error
        //     }
        //     dispatch(handleLoader(false));
        //     toast.success(result.message);
        //     navigate("/black-listed-words")
        // } catch (error: any) {
        //     dispatch(handleLoader(false));
        //     toast.error(error.message);
        // }

        try {
            let result;
            if (params.id === "add") {
                const body = {
                    user_name: localStorage.getItem("username"),
                    // black_listed_word : data.black_listed_word
                    ...data
                }
                result = await black_listed_word(body)
                if (result.error) {
                    throw result.error
                }
                navigate("/admin/black-listed-words")
                toast.success(result.result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            } else if (params.id !== "add") {
                const body = {
                    updated_by: createBy!,
                    // client_env: "string",
                    object_id: params.id,
                    ...data
                }
                result = await update_black_listed_word(body)
                if (result.error) {
                    throw result.error
                }
                navigate("/admin/black-listed-words")
                toast.success(result.result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })

            }
            dispatch(handleLoader(false));
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    useEffect(() => {
        if (params.id !== "add") {
            fetchBlackListWordData(params?.id?.toString() ?? "")
        }
    }, [])

    const getFormErrorMessage = (name: string) => {
        return errors[name] && <small className="p-error">{errors[name]?.message?.toString()}</small>
    }


    return (
        <main className="content-wrapper" >
            <div className='container-fluid p-4'>
                <h4 className='mb-4'>{params.id !== "add" ? "Edit Black Listed word" : "Add Black List Word"}</h4>
                <div className='card'>
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>

                            <div className="row gx-4">
                                <div className="mb-4 col-md-6">
                                    <label htmlFor="role name" className="form-label">
                                        Black listed word<span className="text-red-600">*</span>
                                    </label>
                                    <div>
                                        <InputText className="form-control bg-light" {...register("black_listed_word", { required: { value: true, message: "Role name is required" } })} placeholder={params.id === "add" ? "Add word" : "Edit Word"} />
                                    </div>
                                    {getFormErrorMessage("black_listed_word")}
                                </div>
                            </div>
                            {/* <div className="row gx-4">
                                <div className="mb-4 col-md-6">
                                    <label htmlFor="description" className="form-label">
                                        Description<span className="text-red-600">*</span>
                                    </label>
                                    <div>
                                        <InputTextarea rows={6} className="form-control bg-light p-inputtext-lg" {...register("description", { required: { value: true, message: "Description is required" } })} placeholder="Add role description here..." />
                                    </div>
                                    {getFormErrorMessage("description")}
                                </div>
                            </div> */}

                            <div className="mt-2">
                                <Button className="btn btn-outline-dark" type="button" onClick={() => { navigate('/admin/black-listed-words') }}>Cancel</Button>
                                <Button className="btn btn-primary ms-3" type="submit">Save</Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default AddBlackListWord